import Vue from 'vue'
import qs from 'qs'
import paramFilter from './param-filter'
import jsonToFormData from '../utils/jsonToFormData'

export default function getApiGenerator ({
  request = null,
  map, // todo: deprecated
  url,
  method,
  formData,
  config
}) {
  const globalRequest = request

  const globalConfig = {
    c: {},
    r: {},
    u: {},
    d: {},
    list: {},
    updateStatus: {},
    ...config
  }

  const globalUrl = {
    c: 'create',
    r: 'queryForDetail',
    u: 'update',
    d: 'delete',
    list: 'queryForPage',
    updateStatus: 'updateStatus',
    ...map, // todo: deprecated
    ...url,
  }

  const globalMethod = {
    c: 'POST',
    r: 'POST',
    u: 'POST',
    d: 'POST',
    list: 'POST',
    updateStatus: 'POST',
    ...method
  }

  const globalFormData = [
    ...formData ? formData : []
  ]

  if (Vue.prototype.$qs) {
    console.warn('[apiGenerator] 请勿重复挂载$qs')
  } else {
    Vue.prototype.$qs = qs
  }

  if (request instanceof Function) {
    const download = (url, data, config = {}) => {
      if (config.method) {
        return request({
          responseType: 'blob',
          url,
          ...config.method.toUpperCase() === 'GET' ? { params: data } : { data },
          ...config
        })
        /*.then(() => {
          Vue.prototype.$message?.success?.('操作成功')
        })*/
      } else {
        window.open(url + qs.stringify(data, { addQueryPrefix: true }))
      }
    }

    const upload = (url, data, { method = 'POST' } = {}) => {
      return request({
        url,
        method,
        data: jsonToFormData(data),
        ...config
      })
    }

    if (Vue.prototype.$request) {
      console.warn('[apiGenerator] 请勿重复挂载$request')
    } else {
      Object.defineProperty(Vue.prototype, '$request', {
        value: request
      })
    }

    if (Vue.prototype.$download) {
      console.warn('[apiGenerator] 请勿重复挂载$download')
    } else {
      Object.defineProperty(Vue.prototype, '$download', {
        value: download
      })
    }

    // todo: deprecated
    if (Vue.prototype.$upload) {
      console.warn('[apiGenerator] 请勿重复挂载$upload')
    } else {
      Object.defineProperty(Vue.prototype, '$upload', {
        value: upload
      })
    }

    // todo: get和post为兼容遗留代码
    ['get', 'post', 'GET', 'POST', 'DELETE', 'PATCH', 'HEAD', 'PUT'].map(v => {
      const value = (url, data, config = {}) => {
        if (data) {
          data = paramFilter(data)
        }

        return request({
          method: v,
          url,
          ...v.toUpperCase() === 'GET' ? { params: data } : { data },
          ...config
        })
      }

      value.download = function () {
        // arguments不适用于箭头函数
        const [url, data, config] = arguments
        if (config?.method) {
          console.warn('[apiGenerator] method无法重复指定')
        }
        return download(url, data, {
          ...config,
          method: v,
        })
      }

      value.upload = function () {
        // arguments不适用于箭头函数
        const [url, data, config] = arguments
        if (config?.method) {
          console.warn('[apiGenerator] method无法重复指定')
        }
        return upload(url, data, {
          ...config,
          method: v,
        })
      }

      if (Vue.prototype['$' + v]) {
        console.warn(`[apiGenerator] 请勿重复挂载$` + v)
      } else {
        Object.defineProperty(Vue.prototype, '$' + v, {
          value
        })
      }
    })
  }

  /**
   * @param {string} module - 接口模块前缀
   * @param {object} url - 默认接口地址混入
   */
  return function apiGenerator (module = '', {
    request,
    map, // todo: deprecated
    config,
    url,
    method,
    formData,
    extension = []
  } = {}) {
    request = request || globalRequest
    const instanceConfig = {
      ...globalConfig,
      ...config
    }
    url = {
      ...globalUrl,
      ...map, // todo: deprecated
      ...url
    }
    method = {
      ...globalMethod,
      ...method
    }
    formData = [
      ...globalFormData ? globalFormData : [],
      ...formData ? formData : []
    ]

    const getUrl = (suffix, objForConfig) =>
      typeof suffix === 'function' ? suffix(objForConfig) :
        suffix.startsWith('/') ? suffix : (module.endsWith('/') ? module : module + '/') + suffix

    const api = {
      c: (obj, objIs = 'param', config) => {
        return request({
          url: getUrl(url.c, obj),
          method: method.c,
          ...objIs === 'param' && { data: formData.includes('c') ? jsonToFormData(obj) : obj },
          ...typeof instanceConfig.c === 'function' ? instanceConfig.c(obj) : instanceConfig.c,
          ...config,
        })
      },
      u: (obj, objIs = 'param', config) => {
        return request({
          url: getUrl(url.u, obj),
          method: method.u,
          ...objIs === 'param' && { data: formData.includes('u') ? jsonToFormData(obj) : obj },
          ...typeof instanceConfig.u === 'function' ? instanceConfig.u(obj) : instanceConfig.u,
          ...config,
        })
      },
      list: (obj, objIs = 'param', config) => {
        return request({
          url: getUrl(url.list, obj),
          method: method.list,
          ...objIs === 'param' && { data: formData.includes('list') ? jsonToFormData(obj) : obj },
          ...typeof instanceConfig.list === 'function' ? instanceConfig.list(obj) : instanceConfig.list,
          ...config,
        })
      },
      r: url.r && (
        (obj, objIs = 'param', config) => request({
          url: getUrl(url.r, obj),
          method: method.r,
          ...objIs === 'param' && { data: formData.includes('r') ? jsonToFormData(obj) : obj },
          ...typeof instanceConfig.r === 'function' ? instanceConfig.r(obj) : instanceConfig.r,
          ...config,
        })
      ),
      d: (obj, objIs = 'param', config) => {
        return request({
          url: getUrl(url.d, obj),
          method: method.d,
          ...objIs === 'param' && { data: formData.includes('d') ? jsonToFormData(obj) : obj },
          ...typeof instanceConfig.d === 'function' ? instanceConfig.d(obj) : instanceConfig.d,
          ...config,
        })
      },
      updateStatus: (obj, objIs = 'param', config) => {
        return request({
          url: getUrl(url.updateStatus, obj),
          method: method.updateStatus,
          ...objIs === 'param' && { data: formData.includes('updateStatus') ? jsonToFormData(obj) : obj },
          ...typeof instanceConfig.updateStatus === 'function' ? instanceConfig.updateStatus(obj) : instanceConfig.updateStatus,
          ...config,
        })
      },
    }

    // todo: deprecated
    extension.map(v => {
      if (v) {
        api[v.startsWith('/') ? v.substr(1) : v] = data => request({
          url: module + (v.startsWith('/') ? v : '/' + v),
          method: 'POST',
          data
        })
      }
    })
    if (extension.length) {
      console.warn('[plain-kit] extension已废弃 请直接通过AJAX快捷方式如this.$POST调用接口')
    }

    return api
  }
}
